"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesforceChat = void 0;
const react_native_1 = require("react-native");
const react_native_config_1 = __importDefault(require("react-native-config"));
const Meta_1 = __importDefault(require("../api/Meta"));
const FirebaseCrashlytics_1 = __importDefault(require("../shared/FirebaseCrashlytics"));
class SalesforceChat {
    isLoaded = false;
    initialize(firstName, lastName, prismId, clientId, isInternal, token, t) {
        Meta_1.default.isOpen(token).then(data => {
            if (data.isOpen) {
                /* @ts-ignore */
                var existing = document.getElementById('salesforce-chat-script');
                if (existing) {
                    react_native_1.DeviceEventEmitter.emit("event.showChat", { status: "ready" });
                    react_native_1.DeviceEventEmitter.emit("event.chatLoaded");
                    this.isLoaded = true;
                    return;
                }
                /* @ts-ignore */
                var chatScript = document.createElement('script');
                chatScript.type = 'text/javascript';
                chatScript.async = true;
                chatScript.src = react_native_config_1.default.CHAT_WEB_SCRIPT_URL;
                chatScript.id = 'salesforce-chat-script';
                chatScript.onload = () => {
                    try {
                        /* @ts-ignore */
                        embeddedservice_bootstrap.settings.language = 'en_US';
                        /* @ts-ignore */
                        embeddedservice_bootstrap.settings.hideChatButtonOnLoad = true;
                        /* @ts-ignore */
                        embeddedservice_bootstrap.init(react_native_config_1.default.CHAT_ORGANIZATION_ID, react_native_config_1.default.CHAT_DEVELOPER_NAME_WEB, react_native_config_1.default.CHAT_WEB_EXPERIENCE_URL, {
                            scrt2URL: react_native_config_1.default.CHAT_SCRT_LOCATION
                        });
                    }
                    catch (err) {
                        FirebaseCrashlytics_1.default.log(err);
                        react_native_1.DeviceEventEmitter.emit("event.chatLoaded");
                    }
                };
                /* @ts-ignore */
                window.addEventListener("onEmbeddedMessagingReady", e => {
                    /* @ts-ignore */
                    embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({
                        "First_Name": firstName,
                        "Last_Name": lastName,
                        "PrismId": prismId,
                        "ClientId": clientId,
                        "IsInternal": isInternal ? "Yes" : "No"
                    });
                    react_native_1.DeviceEventEmitter.emit("event.showChat", { status: "ready" });
                    react_native_1.DeviceEventEmitter.emit("event.chatLoaded");
                    this.isLoaded = true;
                });
                /* @ts-ignore */
                document.body.appendChild(chatScript);
            }
        }).catch(err => {
            FirebaseCrashlytics_1.default.log(err);
            react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('company:messages.chatUnavailable') });
        });
    }
    show(token, t) {
        Meta_1.default.isOpen(token).then(data => {
            if (data.isOpen && this.isLoaded) {
                /* @ts-ignore */
                embeddedservice_bootstrap.utilAPI.launchChat().then(() => {
                    react_native_1.DeviceEventEmitter.emit("event.showChat", { status: "visible" });
                }).catch((e) => {
                    console.error('Error launching chat: ', e);
                }).finally(() => {
                    // Perform cleanup operations.
                });
            }
            else {
                react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('company:messages.chatUnavailable') });
            }
        }).catch(err => {
            FirebaseCrashlytics_1.default.log(err);
            react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t('company:messages.chatUnavailable') });
        });
    }
    unload() {
        /* @ts-ignore */
        if (typeof embeddedservice_bootstrap !== 'undefined') {
            this.isLoaded = false;
            /* @ts-ignore */
            embeddedservice_bootstrap?.userVerificationAPI?.clearSession()?.catch((e) => {
                console.error('Error clearing chat session: ', e);
            });
            /* @ts-ignore */
            document.getElementById('salesforce-chat-script')?.remove();
            /* @ts-ignore */
            document.getElementById('embeddedMessagingSiteContextFrame')?.remove();
            /* @ts-ignore */
            document.getElementById('embedded-messaging')?.remove();
            /* @ts-ignore */
            document.getElementById('embeddedMessagingFilePreviewFrame')?.remove();
            /* @ts-ignore */
            document.getElementById('inert-script')?.remove();
            /* @ts-ignore */
            document.getElementById('embeddedMessagingBootstrapStyles')?.remove();
            /* @ts-ignore */
            window.location.reload();
        }
    }
}
exports.SalesforceChat = SalesforceChat;
const Chat = new SalesforceChat();
exports.default = Chat;
